import { TempControlCalculationMethod } from '__generated-api__';

/** Human-readable labels for the wizard Results calculation-method toggle. */
export const CALCULATION_METHOD_LABEL: Record<TempControlCalculationMethod, string> = {
  [TempControlCalculationMethod.Hunters]: "Hunter's",
  [TempControlCalculationMethod.Symmons]: 'Symmons',
};

export const parseCalculationMethod = (method: string | null | undefined): TempControlCalculationMethod => {
  if (method === TempControlCalculationMethod.Symmons) {
    return TempControlCalculationMethod.Symmons;
  }
  if (method === TempControlCalculationMethod.Hunters) {
    return TempControlCalculationMethod.Hunters;
  }
  return TempControlCalculationMethod.Hunters;
};

export const formatCalculationMethodLabel = (method: TempControlCalculationMethod): string => {
  const label = CALCULATION_METHOD_LABEL[method];
  return method === TempControlCalculationMethod.Hunters ? `${label} method` : `${label}' method`;
};

/**
 * Facility types sized additively via the Max Use method rather than a
 * Hunter's ASME curve. Plain string literals (matching the API enum values
 * and the backend `FacilityType::usesMaxUseFlow()`) so this stays dependency-
 * free and safe to bundle into the Node PDF CLI. `enums.facilityUsesFlowRate`
 * delegates here so there is a single source of truth on the frontend.
 */
const MAX_USE_FACILITIES = new Set<string>(['club', 'gym', 'industrial', 'maximum_flow']);

export const isMaxUseFacility = (facility?: string | null): boolean =>
  typeof facility === 'string' && MAX_USE_FACILITIES.has(facility);

/**
 * Uppercase label for PDF footers and similar print surfaces. Max Use
 * facilities size additively rather than on the Hunter's curve, so the
 * printed method reflects that instead of claiming Hunter's.
 */
export const formatStoredCalculationMethodForPdf = (
  method: string | null | undefined,
  facility?: string | null
): string => {
  const parsed = parseCalculationMethod(method);
  if (parsed === TempControlCalculationMethod.Hunters && isMaxUseFacility(facility)) {
    return 'MAXIMUM USE';
  }
  return CALCULATION_METHOD_LABEL[parsed].toUpperCase();
};
